import { currentUser } from '../api/client'

// [RGM] 2026-10-03 (pedido Rafael): prefijo telefónico del PAÍS DE LA EMPRESA.
// Cuenta.PaisCodigo es el código telefónico internacional (57 Colombia,
// 505 Nicaragua, 51 Perú…) — el mismo que usa el registro de empresa.
// Ej. con empresa de Nicaragua: `+505`.
export const prefijoPais = (): string => {
  const pais = currentUser()?.paisCodigo
  return pais ? `+${pais}` : ''
}

// Número completo para los links de WhatsApp (`wa.me`): indicativo del país
// de la empresa + los dígitos del celular (limpia espacios/guiones). Si el
// número ya trae el indicativo adelante, no lo duplica.
export const numeroWhatsApp = (celular: string | null | undefined): string => {
  const digitos = String(celular ?? '').replace(/\D/g, '')
  if (!digitos) return ''
  const indicativo = String(currentUser()?.paisCodigo ?? '')
  if (!indicativo) return digitos
  return digitos.startsWith(indicativo) ? digitos : `${indicativo}${digitos}`
}
